import {gql} from '@apollo/client';

export const login = gql`  
  mutation Login($input: LoginInput!) {
      login(input: $input) {
          token
      }
  }
`;
